import type { SVGProps } from "react";
export default function SvgGoNoGoAppNoShadow(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 112 112"
			{...props}
		>
			<foreignObject width={108.676} height={108.683} x={-3} y={6.31738}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1110_673_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_i_1110_673)">
				<path
					fill="url(#paint0_linear_1110_673)"
					fillOpacity={0.6}
					d="M83.012 24.317H19.664A4.664 4.664 0 0 0 15 28.982v63.354A4.664 4.664 0 0 0 19.664 97h63.348a4.664 4.664 0 0 0 4.664-4.664V28.982a4.664 4.664 0 0 0-4.664-4.665"
				/>
				<path
					stroke="url(#paint1_linear_1110_673)"
					d="M19.664 24.817h63.348c2.3 0 4.164 1.865 4.164 4.164v63.355c0 2.3-1.865 4.164-4.164 4.164H19.664a4.165 4.165 0 0 1-4.164-4.164V28.98c0-2.3 1.865-4.164 4.164-4.164Z"
				/>
			</g>
			<g filter="url(#filter1_i_1110_673)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M91.967 83.56 75.35 70.436a4.66 4.66 0 0 0-5.779 0L52.954 83.56c-2.037 1.611-5.035.159-5.035-2.439V20.284A5.283 5.283 0 0 1 53.202 15h38.514A5.283 5.283 0 0 1 97 20.284v60.838c0 2.597-2.998 4.05-5.036 2.438z"
				/>
				<path
					stroke="url(#paint2_linear_1110_673)"
					strokeOpacity={0.5}
					d="M53.202 15.5h38.514a4.784 4.784 0 0 1 4.784 4.784v60.837c0 2.165-2.48 3.38-4.19 2.073l-.033-.026L75.66 70.043a5.16 5.16 0 0 0-6.398 0L52.645 83.168c-1.71 1.352-4.226.133-4.226-2.047V20.284a4.783 4.783 0 0 1 4.783-4.784Z"
				/>
			</g>
			<path
				fill="#FAFF00"
				d="m73.8 30.288 2.863 4.854c.219.372.582.634 1.003.73l5.502 1.222a1.555 1.555 0 0 1 .828 2.548l-3.733 4.223a1.56 1.56 0 0 0-.383 1.179l.539 5.61a1.555 1.555 0 0 1-2.168 1.573l-5.168-2.245a1.55 1.55 0 0 0-1.24 0l-5.167 2.245a1.555 1.555 0 0 1-2.168-1.573l.54-5.61a1.56 1.56 0 0 0-.384-1.18l-3.733-4.222a1.555 1.555 0 0 1 .827-2.548l5.503-1.223c.42-.092.784-.357 1.003-.729l2.862-4.854a1.554 1.554 0 0 1 2.678 0z"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1110_673"
					x1={51.5231}
					x2={51.5231}
					y1={24.3174}
					y2={96.9997}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1110_673"
					x1={51.3378}
					x2={24.4997}
					y1={25.1134}
					y2={84.7502}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1110_673"
					x1={72.4593}
					x2={72.4593}
					y1={15}
					y2={84.2358}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<filter
					id="filter0_i_1110_673"
					width={108.676}
					height={108.683}
					x={-3}
					y={6.31738}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_673" />
				</filter>
				<filter
					id="filter1_i_1110_673"
					width={85.0806}
					height={105.235}
					x={29.9189}
					y={-3}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_673" />
				</filter>
				<clipPath id="bgblur_0_1110_673_clip_path" transform="translate(3 -6.317)">
					<path d="M83.012 24.317H19.664A4.664 4.664 0 0 0 15 28.982v63.354A4.664 4.664 0 0 0 19.664 97h63.348a4.664 4.664 0 0 0 4.664-4.664V28.982a4.664 4.664 0 0 0-4.664-4.665" />
				</clipPath>
			</defs>
		</svg>
	);
}
